import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/auth.store'
import { usePersonStore } from '@/stores/person.store'
import ddVoteService from '@/services/ddVote.service'

export const useDdVote = defineStore('ddVote', () => {
  const votes        = ref([])
  const currentDealId = ref(null)

  const authStore   = useAuthStore()
  const personStore = usePersonStore()

  const underwriters = computed(() => personStore.underwriters)

  // 'approved' | 'rejected' | 'pending' | null
  const votingStatus = computed(() => {
    if (votes.value.length === 0) return null
    if (votes.value.some(v => v.verdict === 'reject')) return 'rejected'
    if (votes.value.filter(v => v.verdict === 'approve').length >= 2) return 'approved'
    return 'pending'
  })

  const myVote = computed(() => {
    const uid = authStore.currentUser?.id
    return votes.value.find(v => v.userId === uid) ?? null
  })

  function loadData(payload) {
    votes.value         = payload.ddVotes || []
    currentDealId.value = payload.dealId  || null
  }

  async function castVote(verdict, comment = null) {
    const response = await ddVoteService.castVote(currentDealId.value, verdict, comment)
    votes.value = response.ddVotes || []
    return response
  }

  async function removeVote() {
    const response = await ddVoteService.removeVote(currentDealId.value)
    votes.value = response.ddVotes || []
    return response
  }

  return {
    votes,
    underwriters,
    votingStatus,
    myVote,
    loadData,
    castVote,
    removeVote,
  }
}, { persist: false })
